import { useEffect } from "react";
import { bannerImages } from "../utils/constants";
import { Link } from "react-router-dom";

const HomeSlider = ({ banners }) => {
    useEffect(() => {
        // Ensure images are preloaded
        banners.forEach((banner) => {
            const img = new Image();
            img.src = `assets/img/${banner.image || 'default-image.png'}`;
        });
    }, [banners]);

    return (
        <div className="home-slider margin-bottom-0">
            {banners.map((banner, index) => {
                // const bannerImage = `url(assets/img/${bannerImage})` + bannerImages[index];
                const bannerImage = `url(${banner.image})`;

                return (
                    <div
                        key={`banner-${index}`}
                        className="item"
                        style={{
                            backgroundImage: bannerImage,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="home-slider-container">
                                        <div className="home-slider-desc">
                                            <div className="home-slider-title mb-4">
                                                {/* <h5 className="theme-cl fs-sm ft-ragular mb-0">
                                                    {banner.item_category?.name || "Default Category"}
                                                </h5> */}
                                                {banner.title && <h1 className="mb-1 ft-bold lg-heading">
                                                    {banner.title}
                                                </h1>}
                                                {banner.description && <span className="trending">
                                                    {banner.description}
                                                </span>}

                                            </div>
                                            {/* <Link to={`/productlist?category_id=${banner.item_category.id}`}>
                                                <a className="btn stretched-link borders">
                                                    Shop Now
                                                    <i className="lni lni-arrow-right ml-2" />
                                                </a>
                                            </Link> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default HomeSlider;
